import Millimetre from "./Millimetre";

function MillimetreCubed() {
  return <Millimetre exponent={3} />;
}

export default MillimetreCubed;
